import {http} from "../utils/http";
import {Response} from '../types/resp';
export const main_wallet = {
	addCashbackToProduct: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/addCashbackToProduct', payload)
	},

	addCommissionToProduct: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/addCommissionToProduct', payload)
	},

	getDepositSpecialTransaction: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/getDepositSpecialTransactions', payload)
	},

	takePromotion: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/takePromotion', payload)
	},

	addCouponToProduct: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/addCouponToProduct', payload)
	},

	checkConditionAddCreditSpecialType: async () => {
		return http.get<Response<any>>('/mainwallet/checkConditionAddCreditSpecialType')
	},

	depositAffiliate: async () => {
		return http.get<Response<any>>('/mainwallet/depositAffiliate')
	},

	addFortuneToProduct: async () => {
		return http.get<Response<any>>('/mainwallet/addFortuneToProduct')
	},

	previewFortuneTurnOver: async () => {
		return http.get<Response<any>>('/mainwallet/previewFortuneTurnOver')
	},

	getCustomerTurnOverDetail: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/getCustomerTurnOverDetail', payload)
	},

	uploadSlip: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/uploadSlip', payload)
	},

	getRejectTrans: async () => {
		return http.get<Response<any>>('/mainwallet/getRejectTrans')
	},

	receiveRejectTrans: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/receiveRejectTrans', payload)
	},

	p2pGenerateQr: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/p2pGenerateQr', payload)
	},

	receiveBonus: async (payload: any) => {
		return http.post<Response<any>>('/mainwallet/receiveBonus', payload)
	},
}
